export const STATUS_ORDER = { SUSPENDUE: 0, RESERVES: 1, AUTORISEE: 2 };

export const ADMIN = {
  navTab: (name) => `admin-nav-tab-${name}`,
};

export const APP = {
  kpiAutorises: "kpi-count-authorized",
  kpiReserves: "kpi-count-reserves",
  kpiSuspendus: "kpi-count-suspended",
  kpiAnomaliesCritiques: "kpi-count-critical-anomalies",
  kpiActionsRetard: "kpi-count-overdue-actions",
  kpiInspectionsJour: "kpi-count-inspections-today",
  priorityAlertsContainer: "priority-alerts-container",
  statusCardFront: (id) => `status-card-front-${id}`,
  btnNewInspection: "btn-new-inspection",
  btnTriggerSuspension: "btn-trigger-suspension",
  btnReturnToService: "btn-return-to-service",
  tabFrontOverview: "tab-front-overview",
  tabFrontInspections: "tab-front-inspections",
  tabFrontAnomalies: "tab-front-anomalies",
  tabFrontActions: "tab-front-actions",
  tabFrontPhotos: "tab-front-photos",
  tabFrontHistory: "tab-front-history",
  checklistItemToggle: (id, val) => `checklist-item-toggle-${id}-${val}`,
};
